import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { searchUserList } from '@/views/cardSystem/saleToos/api';
var isResigned = function isResigned(item) {
  return !!(item.status_cn && item.status_cn !== '在职');
};

// 离职人员排在最后，其余保持接口返回顺序
var sortResignedLast = function sortResignedLast(list) {
  var active = [];
  var resigned = [];
  list.forEach(function (item) {
    return (isResigned(item) ? resigned : active).push(item);
  });
  return active.concat(resigned);
};
export default {
  data: function data() {
    return {
      personOptions: {},
      personLoading: false,
      personOptionCache: {}
    };
  },
  methods: {
    formatPersonLabel: function formatPersonLabel(item) {
      var status = item.status_cn;
      return item.name + (status && status !== '在职' ? '（' + status + '）' : '');
    },
    searchPerson: function searchPerson(keyword, field, getSelected) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              kw = (keyword || '').trim();
              _this.personLoading = true;
              _context.p = 1;
              _context.n = 2;
              return searchUserList({
                keyword: kw
              });
            case 2:
              res = _context.v;
              // 默认最多展示 50 条，搜索同样限制
              list = sortResignedLast(res.data || []).slice(0, 50);
              list.forEach(function (item) {
                _this.personOptionCache[String(item.id)] = item;
              });
              // 换关键字后已选项仍需有 option 可回显
              selected = getSelected();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this.personOptionCache[String(id)];
              }).filter(Boolean);
              _this.$set(_this.personOptions, field, sortResignedLast(picked.concat(list)));
            case 3:
              _context.p = 3;
              _this.personLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 3, 4]]);
      }))();
    }
  }
};